export default "/images/c0fca9ee20c284dbb2b7b9756c7a2b0b.avif";